import TetherComponent from './TetherComponent';

export default TetherComponent;
